// import { inheritLinks } from "./../inherit-links/inheritlinks.js";

export const xmllibtranslate = {
  data: function (request, lang, url) {
    return {
      translation: request,
      lang: lang,
      url: url,
    };
  },
  buildUrl: function () {
    let siteUrl =
      window.location.protocol +
      "//" +
      window.location.host +
      "/wp-content/themes/edsa-2022/request.php";
    return siteUrl;
  },
  get: function (request, lang, url) {
    let modifyRequest = request;
    // modifyRequest.forEach((a) => delete a.node); // Remove Array Key

    const userAction = async () => {
      const response = await fetch(this.buildUrl(), {
        method: "POST",
        body: JSON.stringify({
          translation: modifyRequest,
          lang: lang,
          url: url,
          p: false,
        }), // string or object
        headers: {
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json",
        },
      });

      const myJson = await response.json(); //extract JSON from the http response
      // do something with myJson

      let err = false;

      request.forEach((elem, i) => {
        if (myJson[i]) {
          elem.node.innerHTML = myJson[i][0];
        } else {
          err = true;
        }
      });

      if (err === true) {
        // Make new Request on Failure to Delete the File
        const response = await fetch(this.buildUrl(), {
          method: "POST",
          body: JSON.stringify({
            translation: modifyRequest,
            lang: lang,
            url: url,
            p: true,
          }), // string or object
          headers: {
            Accept: "application/json, text/plain, */*",
            "Content-Type": "application/json",
          },
        });

        // Re-Initialise New Request
        userAction();
      }

      document.getElementById("load-translate").classList.remove("active");

      //request.node.innerHTML = myJson;
    };
    userAction();
  },
};
